var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeve1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 112,
    viewBox: "0 0 36 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1095 87.6314C11.4914 89.4911 15.5872 101.089 15.5872 101.089C16.2781 103.372 19.3083 106.021 20.0992 106.602C21.4145 107.698 22.5633 108.57 23.5539 109.251C23.5872 109.275 23.6205 109.292 23.6455 109.309C23.6455 109.309 22.1804 111.633 17.71 107.715C17.71 107.715 15.1127 104.693 13.0898 104.319C11.0752 103.954 10.6506 100.616 10.6506 100.616C8.57776 92.9033 3.52466 86.3694 3.68283 82.1685",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0918 56.7139C28.0991 60.948 30.9795 66.2034 30.9795 66.2034C30.9795 66.2034 31.9701 69.242 32.0367 71.9984C33.6351 76.8386 31.4706 83.6216 32.0367 87.4738C32.0367 87.4738 32.6444 90.9359 32.1449 93.8666C32.1449 93.8666 34.1262 106.129 27.225 101.538C23.6121 98.5989 23.995 89.8732 23.7536 82.177L22.9378 81.3301C22.9378 81.3301 22.2968 81.712 21.6641 81.82C21.0231 81.9279 21.9472 83.0653 20.457 84.3854C20.457 84.3854 21.6225 85.6722 20.7401 87.7229C20.7401 87.7229 22.1553 90.4377 20.457 90.7947C22.2552 91.2513 22.8629 100.616 25.2604 101.945C25.2604 101.945 26.5591 103.265 26.5507 104.909C26.5507 104.909 30.6798 107.615 30.147 109.674C30.147 109.674 30.4217 113.925 23.6454 109.309",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6506 100.616C10.6506 100.616 8.36135 99.238 7.29579 95.2613C7.72035 93.9412 0.061604 83.4554 1.08554 79.2046C1.08554 79.2046 1.08554 79.1963 1.11052 79.1382C1.11884 79.1216 1.12717 79.0967 1.14382 79.0718L1.42686 78.4408C1.46016 78.3661 1.50178 78.2831 1.5434 78.1918C1.7099 77.8265 1.93467 77.3449 2.24268 76.6807C2.30928 76.5313 2.39253 76.3736 2.46745 76.1992",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6257 75.8673C2.57575 75.9835 2.51748 76.0915 2.46753 76.1994L2.24276 76.6809L1.54348 78.1919L1.42694 78.441L1.1439 79.072C1.1439 79.072 1.11892 79.1218 1.1106 79.1384L1.0773 79.2048C-0.637592 76.2741 2.14286 72.0566 2.67565 63.8373C2.67565 63.8373 2.76722 61.0394 3.60802 53.6006",
    stroke: "black",
    strokeWidth: 0.154226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.475 0.540527C33.9932 6.56798 32.861 25.7712 32.5114 35.3935C34.0265 37.5853 31.9453 56.6556 31.6873 56.5145C30.0972 56.6141 28.5655 56.6722 27.092 56.7055C15.4957 56.8881 7.61217 54.9288 3.60798 53.5921C1.5601 52.903 0.527832 52.38 0.527832 52.38C2.56739 42.4587 1.11056 33.0689 2.12618 32.0062C2.35095 21.7944 2.42587 9.68134 2.56739 0.557132",
    fill: "#737474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.475 0.540527C33.9932 6.56798 32.861 25.7712 32.5114 35.3935C34.0265 37.5853 31.9453 56.6556 31.6873 56.5145C30.0972 56.6141 28.5655 56.6722 27.092 56.7055C15.4957 56.8881 7.61217 54.9288 3.60798 53.5921C1.5601 52.903 0.527832 52.38 0.527832 52.38C2.56739 42.4587 1.11056 33.0689 2.12618 32.0062C2.35095 21.7944 2.42587 9.68134 2.56739 0.557132",
    stroke: "#231F20",
    strokeWidth: 0.154226,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92529 32.355C2.92529 32.355 14.0471 36.3152 31.6206 35.3936",
    stroke: "black",
    strokeWidth: 0.0925358,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8478 54.9705C30.3351 54.9705 30.7302 54.0672 30.7302 52.953C30.7302 51.8388 30.3351 50.9355 29.8478 50.9355C29.3604 50.9355 28.9653 51.8388 28.9653 52.953C28.9653 54.0672 29.3604 54.9705 29.8478 54.9705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeve1);
export default __webpack_public_path__ + "static/media/sleeve-1.e45ad8b519bae368bb76174a90eb7d93.svg";
export { ForwardRef as ReactComponent };